const HMRC_TRACE_REQUEST_SUBMITTED = 'pp/findPensions/HMRC_TRACE_REQUEST_SUBMITTED';
const HMRC_TRACE_YES_SELECTED = 'pp/findPensions/HMRC_TRACE_YES_SELECTED';
const HMRC_TRACE_NO_SELECTED = 'pp/findPensions/HMRC_TRACE_NO_SELECTED';

export const hmrcTraceRequestSubmittedAction = () => ({ type: HMRC_TRACE_REQUEST_SUBMITTED });
export const hmrcTraceRequestYesSelectedAction = () => ({ type: HMRC_TRACE_YES_SELECTED });
export const hmrcTraceRequestNoSelectedAction = () => ({ type: HMRC_TRACE_NO_SELECTED });
